import React, { useRef, useEffect, useState } from 'react';
import { useGlobalVariablesContext } from '../../context/GlobalVariablesContext';
import { useTranslation } from 'react-i18next';
import './PopUpComponent.css';

/**
 * Componente PopUp para mostrar información en el mapa
 * @component
 * @author Eva Rabasco
 */
const PopUpComponent = () => {
    const { t } = useTranslation();
    const { 
        popUpVisible, 
        setPopUpVisible, 
        popUpPosition, 
        setPopUpPosition, 
        popUpContent 
    } = useGlobalVariablesContext();

    const popupRef = useRef(null);
    const [calculatedPosition, setCalculatedPosition] = useState({ x: 0, y: 0 });

    useEffect(() => {
        if (popUpVisible && popUpPosition && popupRef.current) {
            const popupElement = popupRef.current;
            const rect = popupElement.getBoundingClientRect();
            
            // Calcular posición para que el triángulo apunte al cursor
            const x = popUpPosition.x - (rect.width / 2); // Centrar horizontalmente
            const y = popUpPosition.y - rect.height - 10; // Posicionar arriba del cursor
            
            setCalculatedPosition({ x, y });
        }
    }, [popUpVisible, popUpPosition, popUpContent]);

    if (!popUpVisible || !popUpPosition) {
        return null;
    }

    const handleClose = () => {
        setPopUpVisible(false);
        setPopUpPosition(null);
    };

    return (
        <div 
            ref={popupRef}
            className="popup-container"
            style={{
                position: 'absolute',
                left: calculatedPosition.x,
                top: calculatedPosition.y,
                zIndex: 1000
            }}
        >
            <div className="popup-content">
                <div className="popup-body">
                    <div className="popup-title-row">
                        <div dangerouslySetInnerHTML={{ __html: popUpContent }} />
                        <button 
                            className="popup-close-btn"
                            onClick={handleClose}
                            aria-label={t('Close')}
                        >
                            ×
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PopUpComponent;
